import { I18nShape } from '@tribeplatform/react-components/i18n'

export const auditLogsActionTypesFactory = (intl: I18nShape) => {
  const { $t } = intl
  return [
    {
      value: '',
      text: $t({
        defaultMessage: 'All types',
        id: 'Generics.AllTypes',
      }),
    },
    {
      value: 'SPACE',
      text: $t({
        defaultMessage: '{SPACE_CC}',
        id: 'Generics.Space',
      }),
    },
    {
      value: 'POST',
      text: $t({
        defaultMessage: 'Post',
        id: 'Generics.Post.Noun',
      }),
    },
    {
      value: 'MEMBER',
      text: $t({
        defaultMessage: '{MEMBER_CC}',
        id: 'Generics.Member',
      }),
    },
    {
      value: 'NETWORK',
      text: $t({
        defaultMessage: '{COMMUNITY_CC}',
        id: 'Generics.Community',
      }),
    },
    {
      value: 'COLLECTION',
      text: $t({
        defaultMessage: '{COLLECTION_CC}',
        id: 'Generics.Collection',
      }),
    },
    {
      value: 'REACTION',
      text: $t({
        defaultMessage: 'Reaction',
        id: 'Admin.AuditLogs.Filters.ActionType.Values.Reaction',
      }),
    },
    {
      value: 'MODERATION',
      text: $t({
        defaultMessage: 'Moderation',
        id: 'Generics.Moderation',
      }),
    },
    {
      value: 'MEMBER_INVITATION',
      text: $t({
        defaultMessage: 'Invitation',
        id: 'Generics.Invitation',
      }),
    },
    {
      value: 'APP_INSTALLATION',
      text: $t({
        defaultMessage: 'App Installation',
        id: 'Generics.AppInstallation',
      }),
    },
    {
      value: 'APP',
      text: $t({
        defaultMessage: 'App',
        id: 'Generics.App',
      }),
    },
    {
      value: 'SSO',
      text: $t({
        defaultMessage: 'SSO',
        id: 'Generics.SSO',
      }),
    },
  ]
}
